const a3PaySetupLv: Record<string, string> = {
  "a3PaySetup.a11y.paymentAccountSummary": "Maksājumu kontu kopsavilkums",
  "a3PaySetup.a11y.providersAndMethods": "Pakalpojumu sniedzēji un maksājumu metodes",
  "a3PaySetup.a11y.headerActions": "Maksājumu kontu darbības",
  "a3PaySetup.a11y.stickyNextAction": "Nākamā iestatīšanas darbība",
  "a3PaySetup.actions.activate": "Aktivizēt",
  "a3PaySetup.actions.apply": "Pielietot",
  "a3PaySetup.actions.check": "Pārbaudīt",
  "a3PaySetup.actions.configureMethods": "Konfigurēt metodes",
  "a3PaySetup.actions.connectProvider": "Pieslēgt sniedzēju",
  "a3PaySetup.actions.continueSetup": "Turpināt iestatīšanu",
  "a3PaySetup.actions.deletePreference": "Dzēst iestatījumu",
  "a3PaySetup.actions.load": "Ielādēt",
  "a3PaySetup.actions.manageReceiptSettings": "Pārvaldīt čeku iestatījumus",
  "a3PaySetup.actions.moreActions": "Vairāk darbību",
  "a3PaySetup.actions.notMine": "Nav mans",
  "a3PaySetup.actions.openDisputes": "Atvērt strīdus",
  "a3PaySetup.actions.openExport": "Atvērt eksportu",
  "a3PaySetup.actions.openPayments": "Atvērt maksājumus",
  "a3PaySetup.actions.openPayouts": "Atvērt izmaksas",
  "a3PaySetup.actions.openReceipts": "Atvērt čekus",
  "a3PaySetup.actions.openReconciliation": "Atvērt saskaņošanas problēmas",
  "a3PaySetup.actions.openRefunds": "Atvērt atmaksas",
  "a3PaySetup.actions.refresh": "Atsvaidzināt",
  "a3PaySetup.actions.rollback": "Atgriezt",
  "a3PaySetup.actions.save": "Saglabāt",
  "a3PaySetup.actions.saveDraft": "Saglabāt melnrakstu",
  "a3PaySetup.actions.send": "Nosūtīt",
  "a3PaySetup.actions.setProviderAccount": "Iestatīt sniedzēja kontu",
  "a3PaySetup.actions.showTechnicalDetails": "Rādīt tehniskās detaļas",
  "a3PaySetup.actions.testTableServicePayment": "Testēt Table Service maksājumu",
  "a3PaySetup.actions.trace": "Izsekot",
  "a3PaySetup.actions.updateAccountData": "Atjaunot kontu datus",
  "a3PaySetup.common.a3Pay": "A3 Pay",
  "a3PaySetup.common.accountConnected": "Konts pieslēgts",
  "a3PaySetup.common.accountNotConnected": "Nav pieslēgts",
  "a3PaySetup.common.actionNeeded": "Nepieciešama darbība",
  "a3PaySetup.common.amount": "Summa",
  "a3PaySetup.common.available": "Pieejams",
  "a3PaySetup.common.blocked": "Bloķēts",
  "a3PaySetup.common.canChangeData": "Var mainīt datus",
  "a3PaySetup.common.channel": "Kanāls",
  "a3PaySetup.common.checking": "Pārbauda",
  "a3PaySetup.common.currency": "Valūta",
  "a3PaySetup.common.deleted": "Dzēsts",
  "a3PaySetup.common.email": "E-pasts",
  "a3PaySetup.common.enabled": "Ieslēgts",
  "a3PaySetup.common.inProgress": "Procesā",
  "a3PaySetup.common.loadingSettings": "Ielādē iestatījumus",
  "a3PaySetup.common.merchant": "Tirgotājs",
  "a3PaySetup.common.notCompleted": "Nav pabeigts",
  "a3PaySetup.common.notRecordedYet": "Vēl nav ierakstīts",
  "a3PaySetup.common.off": "Izslēgts",
  "a3PaySetup.common.optional": "nav obligāti",
  "a3PaySetup.common.order": "Pasūtījums",
  "a3PaySetup.common.paid": "Apmaksāts",
  "a3PaySetup.common.paymentReference": "Maksājuma atsauce",
  "a3PaySetup.common.privateLink": "Privāta saite",
  "a3PaySetup.common.productConsole": "Produkta konsole",
  "a3PaySetup.common.readOnly": "Tikai skatīšanai",
  "a3PaySetup.common.ready": "Gatavs",
  "a3PaySetup.common.receiptSettings": "Čeku iestatījumi",
  "a3PaySetup.common.recentlyUpdated": "Nesen atjaunots",
  "a3PaySetup.common.reference": "Atsauce",
  "a3PaySetup.common.secureCheckout": "Drošs maksājums",
  "a3PaySetup.common.status": "Statuss",
  "a3PaySetup.common.updated": "Atjaunots",
  "a3PaySetup.common.updatedAt": "Atjaunots {value}",
  "a3PaySetup.common.version": "Versija",
  "a3PaySetup.dates.notUpdatedYet": "Vēl nav atjaunots",
  "a3PaySetup.diagnostics.evidenceExport.description": "Eksportēt maksājumu pieprasījumus, notikumus, izmaksu instrukcijas, aizsargāto līdzekļu ierakstus, izmaksas, pārbaudes lietas un termināļa pierādījumus.",
  "a3PaySetup.diagnostics.evidenceExport.title": "Pierādījumu eksports",
  "a3PaySetup.diagnostics.rawStatusDetails": "Tehniskā statusa detaļas",
  "a3PaySetup.errors.loadPaymentAccounts": "Neizdevās ielādēt maksājumu kontu statusu",
  "a3PaySetup.errors.loadMerchantReadiness": "Neizdevās ielādēt tirgotāja gatavību",
  "a3PaySetup.errors.loadProductionReadiness": "Neizdevās ielādēt produkcijas gatavību",
  "a3PaySetup.errors.loadRegistry": "Neizdevās ielādēt Core Registry ierakstus",
  "a3PaySetup.errors.merchantRequired": "Tirgotājs ir obligāts.",
  "a3PaySetup.errors.loadReceiptPreference": "Šī čeku iestatījumu saite vairs nav pieejama.",
  "a3PaySetup.errors.loadTemplates": "Neizdevās ielādēt veidnes",
  "a3PaySetup.errors.loadTrace": "Neizdevās ielādēt A3 Pay izsekošanu",
  "a3PaySetup.errors.paymentAccountRetry": "Maksājumu kontu statusu jāpārbauda vēlreiz",
  "a3PaySetup.errors.paymentNotFound": "Maksājums netika atrasts.",
  "a3PaySetup.errors.paymentStatusUnavailable": "Maksājuma statuss īslaicīgi nav pieejams.",
  "a3PaySetup.errors.productionReadinessFailed": "Gatavības statuss neizdevās",
  "a3PaySetup.errors.receiptCouldNotSend": "Čeku pašlaik nevar nosūtīt.",
  "a3PaySetup.errors.receiptPreferenceDeletedFailed": "Čeku iestatījumu pašlaik nevar izdzēst.",
  "a3PaySetup.errors.receiptPreferenceSaveFailed": "Čeku iestatījumus pašlaik nevar saglabāt.",
  "a3PaySetup.errors.receiptPreferenceUpdateFailed": "Čeku iestatījumus pašlaik nevar atjaunot.",
  "a3PaySetup.errors.registryFailed": "Reģistra darbība neizdevās",
  "a3PaySetup.errors.saveProviderAccount": "Neizdevās saglabāt sniedzēja kontu",
  "a3PaySetup.errors.saveRegistry": "Neizdevās saglabāt Core Registry ierakstu",
  "a3PaySetup.errors.saveTemplate": "Neizdevās saglabāt veidni",
  "a3PaySetup.errors.technicalMessage": "Tehniskais ziņojums",
  "a3PaySetup.errors.technicalTimestamp": "Laika zīmogs",
  "a3PaySetup.errors.templateMerchantRequired": "Tirgotāja atsauce ir obligāta.",
  "a3PaySetup.errors.traceRetry": "Izsekošanu jāmēģina vēlreiz",
  "a3PaySetup.errors.tryAgainBody": "Mēģiniet vēlreiz. Ja tas atkārtojas, sazinieties ar atbalstu. Tehniskās detaļas ir paslēptas zemāk.",
  "a3PaySetup.errors.updateAccountData": "Neizdevās atjaunot maksājumu kontu datus",
  "a3PaySetup.forms.changeEmail": "Mainīt e-pastu",
  "a3PaySetup.forms.directoryMerchant": "Direktorijas tirgotājs",
  "a3PaySetup.forms.directoryRef": "Direktorijas atsauce",
  "a3PaySetup.forms.enableA3Pay": "Ieslēgt A3 Pay",
  "a3PaySetup.forms.enterPaymentReference": "Ievadiet maksājuma atsauci",
  "a3PaySetup.forms.html": "HTML",
  "a3PaySetup.forms.locale": "Lokalizācija",
  "a3PaySetup.forms.merchantRef": "Tirgotāja atsauce",
  "a3PaySetup.forms.merchantIdPlaceholder": "tirgotāja id",
  "a3PaySetup.forms.optionalPlaceholder": "nav obligāti",
  "a3PaySetup.forms.paymentProviderAccount": "Sniedzēja konts",
  "a3PaySetup.forms.providerAccountPlaceholder": "acct_...",
  "a3PaySetup.forms.paymentReferencePlaceholder": "maksājuma id, idempotences atslēga, sniedzēja maksājuma id",
  "a3PaySetup.forms.paymentRequestRef": "Maksājuma pieprasījuma atsauce",
  "a3PaySetup.forms.replyTo": "Atbildēt uz",
  "a3PaySetup.forms.senderEmail": "Sūtītāja e-pasts",
  "a3PaySetup.forms.senderName": "Sūtītāja vārds",
  "a3PaySetup.forms.sourceMerchantRef": "Tirgotāja atsauce",
  "a3PaySetup.forms.subject": "Temats",
  "a3PaySetup.forms.text": "Teksts",
  "a3PaySetup.header.navigationLabel": "{productName} navigācija",
  "a3PaySetup.header.payTagline": "Reģistrētas PI tiešsaistes maksājumu operācijas",
  "a3PaySetup.nav.acceptance": "Maksājumu pieņemšana",
  "a3PaySetup.nav.accounts": "Konti",
  "a3PaySetup.nav.acquirer": "Termināļa norēķini",
  "a3PaySetup.nav.disputes": "Strīdi",
  "a3PaySetup.nav.evidence": "Pierādījumi",
  "a3PaySetup.nav.merchants": "Tirgotāji",
  "a3PaySetup.nav.operations": "Operācijas",
  "a3PaySetup.nav.payments": "Maksājumi",
  "a3PaySetup.nav.readiness": "Gatavība",
  "a3PaySetup.nav.receiptEmails": "Čeku e-pasti",
  "a3PaySetup.nav.receipts": "Čeki",
  "a3PaySetup.nav.reconciliation": "Maksājumu saskaņošana",
  "a3PaySetup.nav.registry": "Reģistrs",
  "a3PaySetup.nav.remittance": "Izmaksas",
  "a3PaySetup.nav.risk": "Risks",
  "a3PaySetup.nav.riskDisputes": "Risks un strīdi",
  "a3PaySetup.nav.safeguarding": "Aizsargātie līdzekļi",
  "a3PaySetup.nav.safeguardingReconciliation": "Safeguarding un saskaņošana",
  "a3PaySetup.nav.settlementRemittance": "Norēķini un izmaksas",
  "a3PaySetup.nav.supportDiagnostics": "Atbalsta diagnostika",
  "a3PaySetup.nav.trace": "Izsekošana",
  "a3PaySetup.notices.accountDataRefreshed": "Kontu dati atjaunoti",
  "a3PaySetup.notices.paymentAccountDataAlreadyCurrent": "Maksājumu kontu dati jau ir aktuāli.",
  "a3PaySetup.notices.paymentAccountDataUpdated_one": "Maksājumu kontu dati atjaunoti {count} ierakstam.",
  "a3PaySetup.notices.paymentAccountDataUpdated_other": "Maksājumu kontu dati atjaunoti {count} ierakstiem.",
  "a3PaySetup.notices.providerAccountSavedEnabled": "Sniedzēja konts saglabāts A3 Pay un ieslēgts izvēlētajam maksājumam.",
  "a3PaySetup.notices.providerAccountSavedShared": "Sniedzēja konts saglabāts A3 Pay kopīgai maksājumu iestatīšanai.",
  "a3PaySetup.notices.receiptAutomaticOff": "Automātiskie čeki ir izslēgti.",
  "a3PaySetup.notices.receiptAlreadyRequested": "Šis čeks jau ir pieprasīts. Atkārtots e-pasts netika nosūtīts.",
  "a3PaySetup.notices.receiptEmailQueued": "Čeka e-pasts ievietots rindā.",
  "a3PaySetup.notices.receiptFiscalPending": "Maksājums ir pabeigts. Fiskālais čeks vēl tiek sagatavots, tāpēc e-pasta piegāde pagaidīs.",
  "a3PaySetup.notices.receiptPreferenceDeleted": "Šis čeka iestatījums ir izdzēsts.",
  "a3PaySetup.notices.receiptSettingsSaved": "Čeku iestatījumi saglabāti.",
  "a3PaySetup.notices.receiptTryLater": "Čeka e-pasts tika pieprasīts nesen. Mēģiniet vēlāk, ja tas nav pienācis.",
  "a3PaySetup.notices.receiptsAvailableAfterPayment": "Čeks ir pieejams pēc maksājuma pabeigšanas.",
  "a3PaySetup.notices.validEmailRequired": "Ievadiet derīgu e-pastu, ja vēlaties čeku e-pastā.",
  "a3PaySetup.merchantReadiness.blockingLabel": "Bloķē",
  "a3PaySetup.merchantReadiness.blockingWarnings": "{blocking} bloķēti, {warnings} brīdinājumi",
  "a3PaySetup.merchantReadiness.cards.gates": "Gatavības pārbaudes",
  "a3PaySetup.merchantReadiness.cards.merchant": "Tirgotājs",
  "a3PaySetup.merchantReadiness.cards.onlinePayments": "Tiešsaistes maksājumi",
  "a3PaySetup.merchantReadiness.cards.owner": "Īpašnieka Party",
  "a3PaySetup.merchantReadiness.description": "Tirgotāja gatavība tiek noteikta no Core Registry un A3 Pay pierādījumiem, nevis no tehniskām sniedzēja vai direktorijas atsaucēm.",
  "a3PaySetup.merchantReadiness.emptyProvider": "Šim tirgotājam nav aktīva Stripe vai Klix sniedzēja konta.",
  "a3PaySetup.merchantReadiness.emptyRecipients": "Vēl nav piesaistīti norēķinu saņēmēji vai finanšu lomas.",
  "a3PaySetup.merchantReadiness.eyebrow": "Tirgotāja gatavība",
  "a3PaySetup.merchantReadiness.gatesDescription": "Trūkstošie darbi ir sagrupēti pēc atbildīgā īpašnieka.",
  "a3PaySetup.merchantReadiness.operations.lastFailed": "Pēdējais neveiksmīgais maksājums",
  "a3PaySetup.merchantReadiness.operations.lastSuccessful": "Pēdējais veiksmīgais maksājums",
  "a3PaySetup.merchantReadiness.operations.openDisputes": "Atvērti strīdi",
  "a3PaySetup.merchantReadiness.operations.openHolds": "Atvērtas aiztures",
  "a3PaySetup.merchantReadiness.operations.riskCases": "Atvērtas riska lietas",
  "a3PaySetup.merchantReadiness.paymentStatus.disabled": "Izslēgts",
  "a3PaySetup.merchantReadiness.paymentStatus.held": "Aizturēts",
  "a3PaySetup.merchantReadiness.paymentStatus.live": "Live",
  "a3PaySetup.merchantReadiness.paymentStatus.pending_review": "Gaida pārbaudi",
  "a3PaySetup.merchantReadiness.paymentStatus.sandbox": "Sandbox",
  "a3PaySetup.merchantReadiness.paymentStatus.suspended": "Apturēts",
  "a3PaySetup.merchantReadiness.warningsLabel": "Brīdinājumi",
  "a3PaySetup.merchantReadiness.scope.latvia": "Saistīts ar Latviju",
  "a3PaySetup.merchantReadiness.scope.noWallet": "Bez maka vai e-naudas",
  "a3PaySetup.merchantReadiness.scope.onlineOnly": "Tikai tiešsaistē",
  "a3PaySetup.merchantReadiness.scope.volume": "Mēneša apjoms",
  "a3PaySetup.merchantReadiness.sections.eventContext": "Event konteksts",
  "a3PaySetup.merchantReadiness.sections.missing": "Trūkstošās darbības",
  "a3PaySetup.merchantReadiness.sections.missingDescription": "Izpildāmas nepilnības, sagrupētas pēc atbildīgā īpašnieka.",
  "a3PaySetup.merchantReadiness.sections.operations": "Operācijas",
  "a3PaySetup.merchantReadiness.sections.provider": "Sniedzēja adapteris",
  "a3PaySetup.merchantReadiness.sections.providerDescription": "Sniedzēja tehniskās detaļas paliek atbalsta diagnostikā; šeit redzama tikai gatavība.",
  "a3PaySetup.merchantReadiness.sections.recipients": "Norēķinu saņēmēji",
  "a3PaySetup.merchantReadiness.sections.recipientsDescription": "MerchantParty lomas, kas var saņemt izmaksas vai strādāt ar finanšu plūsmām.",
  "a3PaySetup.merchantReadiness.sections.scope": "Reģistrētas PI tvērums",
  "a3PaySetup.merchantReadiness.title": "Tirgotāja gatavība",
  "a3PaySetup.merchantReadiness.noMissing": "Trūkstošu darbību nav.",
  "a3PaySetup.registry.actions.archive": "Arhivēt",
  "a3PaySetup.registry.actions.cancelEdit": "Atcelt labošanu",
  "a3PaySetup.registry.actions.createRecord": "Izveidot ierakstu",
  "a3PaySetup.registry.actions.delete": "Dzēst",
  "a3PaySetup.registry.actions.disable": "Atspējot",
  "a3PaySetup.registry.actions.edit": "Labot",
  "a3PaySetup.registry.actions.editRecord": "Labot ierakstu",
  "a3PaySetup.registry.actions.exportSnapshot": "Eksportēt momentuzņēmumu",
  "a3PaySetup.registry.actions.openReadiness": "Gatavība",
  "a3PaySetup.registry.actions.restore": "Atjaunot",
  "a3PaySetup.registry.actions.showDeleted": "Rādīt dzēstos ierakstus",
  "a3PaySetup.registry.description": "Pārskatiet, labojiet, dzēsiet, atjaunojiet un eksportējiet maksājumiem vajadzīgos Core Registry ierakstus.",
  "a3PaySetup.registry.empty": "Šajā skatā vēl nav ierakstu.",
  "a3PaySetup.registry.eyebrow": "Core Registry Admin",
  "a3PaySetup.registry.formDescription": "Strukturēti ieraksti iet caur Core Registry directory kontraktiem ar versiju un audita pierādījumiem.",
  "a3PaySetup.registry.forms.country": "Valsts",
  "a3PaySetup.registry.forms.currency": "Valūta",
  "a3PaySetup.registry.forms.displayName": "Nosaukums",
  "a3PaySetup.registry.forms.legalStatus": "Juridiskais statuss",
  "a3PaySetup.registry.forms.methodProfile": "Metodes profils",
  "a3PaySetup.registry.forms.ownerParty": "Īpašnieka Party",
  "a3PaySetup.registry.forms.party": "Party",
  "a3PaySetup.registry.forms.partyOptional": "Party (nav obligāti)",
  "a3PaySetup.registry.forms.partyType": "Party tips",
  "a3PaySetup.registry.forms.payoutEvidence": "Izmaksu pierādījums",
  "a3PaySetup.registry.forms.phone": "Tālrunis",
  "a3PaySetup.registry.forms.product": "Produkta tiesība",
  "a3PaySetup.registry.forms.provider": "Sniedzējs",
  "a3PaySetup.registry.forms.providerPath": "Sniedzēja ceļš",
  "a3PaySetup.registry.forms.registeredAddress": "Juridiskā adrese",
  "a3PaySetup.registry.forms.registeredNumber": "Reģistrācijas numurs",
  "a3PaySetup.registry.forms.role": "Loma",
  "a3PaySetup.registry.forms.safeAccountRef": "Droša konta atsauce",
  "a3PaySetup.registry.forms.scope": "Tvērums",
  "a3PaySetup.registry.forms.scopeRecord": "Tvēruma ieraksts",
  "a3PaySetup.registry.forms.selectMerchant": "Izvēlieties tirgotāju",
  "a3PaySetup.registry.forms.selectParty": "Izvēlieties Party",
  "a3PaySetup.registry.forms.selectScope": "Izvēlieties tvēruma ierakstu",
  "a3PaySetup.registry.forms.timezone": "Laika zona",
  "a3PaySetup.registry.listDescription": "Statuss, avots, versija un pēdējā sinhronizācija ir redzami licencēšanas pierādījumiem.",
  "a3PaySetup.registry.notices.archive": "Ieraksts arhivēts.",
  "a3PaySetup.registry.notices.created": "Ieraksts izveidots.",
  "a3PaySetup.registry.notices.delete": "Ieraksts dzēsts, kur iespējams, citādi arhivēts.",
  "a3PaySetup.registry.notices.deletedRecoverable": "Ieraksts pārvietots uz dzēstajiem. Ieslēdziet \"Rādīt dzēstos ierakstus\", lai to atjaunotu.",
  "a3PaySetup.registry.notices.disable": "Ieraksts atspējots.",
  "a3PaySetup.registry.notices.restored": "Ieraksts atjaunots.",
  "a3PaySetup.registry.notices.snapshotReady": "Reģistra momentuzņēmums sagatavots ar {count} ierakstiem.",
  "a3PaySetup.registry.notices.updated": "Ieraksts atjaunots.",
  "a3PaySetup.registry.ownerLinked": "Īpašnieks piesaistīts",
  "a3PaySetup.registry.ownerMissing": "Īpašnieks trūkst",
  "a3PaySetup.registry.safeRefMissing": "Droša atsauce trūkst",
  "a3PaySetup.registry.safeRefRecorded": "Droša atsauce ierakstīta",
  "a3PaySetup.registry.tabs.access": "Piekļuve",
  "a3PaySetup.registry.tabs.accounts": "Konti",
  "a3PaySetup.registry.tabs.entitlements": "Tiesības",
  "a3PaySetup.registry.tabs.memberships": "Dalības",
  "a3PaySetup.registry.tabs.merchants": "Tirgotāji",
  "a3PaySetup.registry.tabs.parties": "Parties",
  "a3PaySetup.registry.title": "A3 Pay reģistrs",
  "a3PaySetup.operations.header.description": "Maksājumu, aizsargāto līdzekļu, pārbaužu un maksājumu saskaņošanas darba vieta.",
  "a3PaySetup.operations.header.title": "A3 Pay operācijas",
  "a3PaySetup.operations.disputes.description_one": "{count} strīdam vajadzīga uzmanība.",
  "a3PaySetup.operations.disputes.description_other": "{count} strīdiem vajadzīga uzmanība.",
  "a3PaySetup.operations.disputes.title": "Strīdi",
  "a3PaySetup.operations.payments.description_one": "{count} maksājuma aizture jāpārskata.",
  "a3PaySetup.operations.payments.description_other": "{count} maksājumu aiztures jāpārskata.",
  "a3PaySetup.operations.payments.title": "Jaunākie maksājumi",
  "a3PaySetup.operations.payouts.description": "Pieejamais atlikums un nākamās izmaksas statuss.",
  "a3PaySetup.operations.payouts.title": "Izmaksas",
  "a3PaySetup.operations.reconciliation.description_one": "{count} maksājumu saskaņošanas problēma jāpārskata.",
  "a3PaySetup.operations.reconciliation.description_other": "{count} maksājumu saskaņošanas problēmas jāpārskata.",
  "a3PaySetup.operations.reconciliation.title": "Maksājumu saskaņošanas problēmas",
  "a3PaySetup.operations.refunds.description": "Atmaksu pieprasījumi un atmaksu vēsture, kur atļauts.",
  "a3PaySetup.operations.refunds.title": "Atmaksas",
  "a3PaySetup.operations.serviceAlerts.description_one": "{count} servisa brīdinājumam vajadzīga uzmanība.",
  "a3PaySetup.operations.serviceAlerts.description_other": "{count} servisa brīdinājumiem vajadzīga uzmanība.",
  "a3PaySetup.operations.serviceAlerts.title": "Servisa brīdinājumi",
  "a3PaySetup.operations.summary.heldPayouts": "Aizturētas izmaksas",
  "a3PaySetup.operations.summary.matchingIssues": "Saskaņošanas problēmas",
  "a3PaySetup.operations.summary.openDisputes": "Atvērti strīdi",
  "a3PaySetup.operations.summary.openReviews": "Atvērtas pārbaudes",
  "a3PaySetup.operations.summary.paymentHolds": "Aizturēti maksājumi",
  "a3PaySetup.operations.summary.totalReviews": "Pārbaudes kopā",
  "a3PaySetup.operations.tabs.acquirer": "Termināļa norēķini",
  "a3PaySetup.operations.tabs.disputes": "Strīdi",
  "a3PaySetup.operations.tabs.ledger": "Aizsargātie līdzekļi",
  "a3PaySetup.operations.tabs.reconciliation": "Maksājumu saskaņošana",
  "a3PaySetup.operations.tabs.remittance": "Izmaksas",
  "a3PaySetup.operations.tabs.risk": "Pārbaudes",
  "a3PaySetup.paymentAccounts.accountCard.a3PayCheckout": "A3 Pay maksājums",
  "a3PaySetup.paymentAccounts.accountCard.a3PayNeedsSetup": "A3 Pay jāiestata",
  "a3PaySetup.paymentAccounts.accountCard.a3PayNotEnabled": "A3 Pay nav ieslēgts",
  "a3PaySetup.paymentAccounts.accountCard.a3PayReady": "A3 Pay gatavs",
  "a3PaySetup.paymentAccounts.accountCard.directTableServicePayments": "Tiešie Table Service maksājumi",
  "a3PaySetup.paymentAccounts.accountCard.merchantPaymentSetup": "Tirgotāja maksājumu iestatīšana",
  "a3PaySetup.paymentAccounts.accountCard.klixNotConnected": "Klix nav pieslēgts",
  "a3PaySetup.paymentAccounts.accountCard.klixReady": "Klix gatavs",
  "a3PaySetup.paymentAccounts.accountCard.liveReady": "Gatavs tiešraidei",
  "a3PaySetup.paymentAccounts.accountCard.noProviderAccount": "Šim tirgotājam vēl nav importēts sniedzēja konts.",
  "a3PaySetup.paymentAccounts.accountCard.paymentAccount": "Maksājumu konts",
  "a3PaySetup.paymentAccounts.accountCard.stripeDirectNotConnected": "Stripe direct nav pieslēgts",
  "a3PaySetup.paymentAccounts.accountCard.stripeDirectReady": "Stripe direct gatavs",
  "a3PaySetup.paymentAccounts.accountStatus.readyForA3Pay": "Gatavs A3 Pay",
  "a3PaySetup.paymentAccounts.accountStatus.sandboxCheckoutReady": "Testa maksājums gatavs",
  "a3PaySetup.paymentAccounts.accountStatus.stripeDirectAvailable": "Stripe direct pieejams",
  "a3PaySetup.paymentAccounts.capability.cardPresentEvidence": "Termināļa/card-present maksājums caur licencētu pieņēmēju",
  "a3PaySetup.paymentAccounts.capability.bnpl": "Pay Later / BNPL",
  "a3PaySetup.paymentAccounts.capability.disputes": "Strīdi",
  "a3PaySetup.paymentAccounts.capability.hostedCheckout": "Hosted checkout",
  "a3PaySetup.paymentAccounts.capability.latviaBankPis": "Latvijas banku/PIS metodes",
  "a3PaySetup.paymentAccounts.capability.methodWhitelist": "Vajadzīgs metožu whitelist",
  "a3PaySetup.paymentAccounts.capability.onlineCard": "Tiešsaistes karte",
  "a3PaySetup.paymentAccounts.capability.reconciliationFiles": "Saskaņošanas faili",
  "a3PaySetup.paymentAccounts.capability.refunds": "Atmaksas",
  "a3PaySetup.paymentAccounts.capability.transfers": "Pārskaitījumi",
  "a3PaySetup.paymentAccounts.capability.wallets": "Maki",
  "a3PaySetup.paymentAccounts.channels.description": "Aktīvie kanāli paliek piesaistīti tirgotājam un pierādījumiem.",
  "a3PaySetup.paymentAccounts.channels.needsProvider": "Vajadzīgs sniedzējs",
  "a3PaySetup.paymentAccounts.channels.offPendingSignoff": "Izslēgts līdz apstiprinājumam",
  "a3PaySetup.paymentAccounts.channels.title": "Kanāli",
  "a3PaySetup.paymentAccounts.configure.adapterKlix": "Adapters: Klix hosted purchase ar Latvijas banku/PIS whitelist",
  "a3PaySetup.paymentAccounts.configure.adapterStripe": "Adapters: Stripe tiešsaistes maksājumi",
  "a3PaySetup.paymentAccounts.configure.description": "A3 Pay pārvalda hosted provider izvēli Table Service maksājumiem. Stripe un Klix tiek konfigurēti šeit; raw refs paliek diagnostikā.",
  "a3PaySetup.paymentAccounts.configure.findMerchant": "Atrast tirgotāju",
  "a3PaySetup.paymentAccounts.configure.findMerchantPlaceholder": "Meklēt pēc vietas, valsts, valūtas vai statusa",
  "a3PaySetup.paymentAccounts.configure.klixMethodProfile": "Klix metožu profils: tikai Latvijas bankas/PIS",
  "a3PaySetup.paymentAccounts.configure.klixMethodProfileDescription": "Kartes, maki, Pay Later/BNPL un neapstiprinātas pārrobežu metodes paliek izslēgtas līdz atsevišķam apstiprinājumam.",
  "a3PaySetup.paymentAccounts.configure.noMerchantMatches": "Nav atbilstošu tirgotāju",
  "a3PaySetup.paymentAccounts.configure.noProviderAccounts": "Šim tirgotājam nav importētu {provider} kontu",
  "a3PaySetup.paymentAccounts.configure.noStripeAccounts": "Šim tirgotājam nav importētu Stripe kontu",
  "a3PaySetup.paymentAccounts.configure.provider": "Sniedzējs",
  "a3PaySetup.paymentAccounts.configure.providerAccount": "Sniedzēja konts",
  "a3PaySetup.paymentAccounts.configure.providerAccountHint": "Izvēlieties importētu sniedzēja kontu vai vispirms atjaunojiet kontu datus.",
  "a3PaySetup.paymentAccounts.configure.providerKlix": "Klix",
  "a3PaySetup.paymentAccounts.configure.providerStripe": "Stripe",
  "a3PaySetup.paymentAccounts.configure.selectedProviderAccount": "{account} izvēlēts Table Service maksājumiem.",
  "a3PaySetup.paymentAccounts.configure.selectedStripeAccount": "{account} izvēlēts Table Service maksājumiem.",
  "a3PaySetup.paymentAccounts.configure.stripeAccount": "Stripe konts",
  "a3PaySetup.paymentAccounts.configure.stripeAccountPlaceholder": "acct_...",
  "a3PaySetup.paymentAccounts.configure.title": "Maksājumu pieņemšana",
  "a3PaySetup.paymentAccounts.empty.description": "Importējiet Product Directory datus, lai šeit redzētu tirgotāja gatavību un sniedzēja konta statusu.",
  "a3PaySetup.paymentAccounts.empty.title": "Maksājumu konti vēl nav importēti",
  "a3PaySetup.paymentAccounts.header.badge": "Vairāku tirgotāju maksājumu iestatīšana",
  "a3PaySetup.paymentAccounts.header.description": "Skatiet, kuri tirgotāji var pieņemt A3 Pay maksājumus un kuras vietas var turpināt izmantot Stripe direct caur Table Service.",
  "a3PaySetup.paymentAccounts.header.title": "Maksājumu konti",
  "a3PaySetup.paymentAccounts.loadedCount": "Ielādēti: {count}",
  "a3PaySetup.paymentAccounts.loading": "Ielādē maksājumu kontus",
  "a3PaySetup.paymentAccounts.missingSetupTitle": "Dažiem tirgotājiem vajadzīga iestatīšana pirms A3 Pay tiešraides maksājumiem",
  "a3PaySetup.paymentAccounts.providers.description": "Sniedzēja iestatīšana ir atsevišķa no maksājumu metodēm, ko tirgotāji var piedāvāt.",
  "a3PaySetup.paymentAccounts.providers.accounts": "{count} konti",
  "a3PaySetup.paymentAccounts.providers.allowedMethods": "Atļauts: {methods}",
  "a3PaySetup.paymentAccounts.providers.disabledMethods": "Izslēgts: {methods}",
  "a3PaySetup.paymentAccounts.providers.liveReady": "{count} gatavi tiešraidei",
  "a3PaySetup.paymentAccounts.providers.methodProfile": "Metožu profils",
  "a3PaySetup.paymentAccounts.providers.sandboxReady": "{count} gatavi testam",
  "a3PaySetup.paymentAccounts.providers.title": "Sniedzēji un metodes",
  "a3PaySetup.paymentAccounts.readiness.description": "Konta statuss ir tirgotājam saprotams, lai redzētu gatavību bez sniedzēja tehnisko datu lasīšanas.",
  "a3PaySetup.paymentAccounts.readiness.title": "Tirgotāja gatavība",
  "a3PaySetup.paymentAccounts.status.disabled": "Izslēgts",
  "a3PaySetup.paymentAccounts.status.planned": "Plānots",
  "a3PaySetup.paymentAccounts.status.ready": "Gatavs",
  "a3PaySetup.paymentAccounts.status.setupNeeded": "Jāiestata",
  "a3PaySetup.paymentAccounts.summary.a3PayReady": "A3 Pay gatavs",
  "a3PaySetup.paymentAccounts.summary.canCreateSandbox": "{count} var izveidot testa sesijas",
  "a3PaySetup.paymentAccounts.summary.enabledForA3Pay": "{count} ieslēgti A3 Pay",
  "a3PaySetup.paymentAccounts.summary.merchants": "Tirgotāji",
  "a3PaySetup.paymentAccounts.summary.needsSetup": "Jāiestata",
  "a3PaySetup.paymentAccounts.summary.stripeDirect": "Stripe direct",
  "a3PaySetup.paymentAccounts.summary.updatedAt": "Atjaunots {value}",
  "a3PaySetup.paymentAccounts.summary.withoutA3Pay": "{count} bez A3 Pay",
  "a3PaySetup.production.evidence.description": "Izveido datētu Latvijas Bankas paketi ar gatavības, reģistra, lomu/piekļuves un avota sistēmas offline demo pierādījumiem.",
  "a3PaySetup.production.evidence.generatePackage": "Izveidot pierādījumu paketi",
  "a3PaySetup.production.evidence.preLicensingSnapshot": "Pirmslicencēšanas gatavības momentuzņēmums",
  "a3PaySetup.production.evidence.preLicensingSnapshotDetail": "Pievienojami publicēšanas vārti, runbook dokumenti, neatbalstīto kanālu karogi un produkcijas skaiti.",
  "a3PaySetup.production.evidence.registrySnapshot": "Core Registry momentuzņēmums",
  "a3PaySetup.production.evidence.roleAccessExport": "Lomu/piekļuves pārskata eksports",
  "a3PaySetup.production.evidence.roleAccessExportDetail": "Paketē iekļautas produkta lomas, piekļuves izmaiņas un maker/checker lēmumi.",
  "a3PaySetup.production.evidence.standaloneBundle": "Avota sistēmas offline pirmā pakete",
  "a3PaySetup.production.evidence.title": "Licencēšanas pierādījumi",
  "a3PaySetup.production.header.description": "Publicēšanas vārti tikai skatīšanas režīmam, tirgotāju pārejai, rezerves kopijām un sniedzēja izolācijai. Tirgotāja līmeņa palaišana bez avota sistēmas iekšējo detaļu rādīšanas.",
  "a3PaySetup.production.header.title": "Produkcijas gatavība",
  "a3PaySetup.production.runtime.actualDatabase": "Faktiskā datubāze",
  "a3PaySetup.production.runtime.databaseBoundaryChecked": "Datubāzes robeža pārbaudīta",
  "a3PaySetup.production.runtime.databaseBoundaryNotChecked": "Datubāzes robeža nav pārbaudīta",
  "a3PaySetup.production.runtime.description": "Ne-slepeni publicēšanas iestatījumi",
  "a3PaySetup.production.runtime.expectedDatabase": "Sagaidāmā datubāze",
  "a3PaySetup.production.runtime.paymentCutover": "Maksājumu pāreja",
  "a3PaySetup.production.runtime.restoreEvidence": "Atjaunošanas pierādījums",
  "a3PaySetup.production.runtime.settlementCutover": "Izmaksu pāreja",
  "a3PaySetup.production.runtime.title": "Runtime",
  "a3PaySetup.production.sections.isolation.description": "A3 Pay var darboties bez avota sistēmas iekšējām detaļām",
  "a3PaySetup.production.sections.isolation.title": "Izolācija",
  "a3PaySetup.production.sections.operations.accounts": "Konti",
  "a3PaySetup.production.sections.operations.blockedPayments": "Bloķēti maksājumi",
  "a3PaySetup.production.sections.operations.cutoverRefs": "Pārejas atsauces",
  "a3PaySetup.production.sections.operations.description": "Lēmuma pamatā esošie aktīvie pierādījumi",
  "a3PaySetup.production.sections.operations.merchants": "Tirgotāji",
  "a3PaySetup.production.sections.operations.openWork": "Atvērts darbs",
  "a3PaySetup.production.sections.operations.settlementIssues": "Izmaksu problēmas",
  "a3PaySetup.production.sections.operations.title": "Operācijas",
  "a3PaySetup.production.sections.releaseGates.description": "Pašreizējais lēmums šim A3 Pay ieviešanas tvērumam",
  "a3PaySetup.production.sections.releaseGates.title": "Publicēšanas vārti",
  "a3PaySetup.production.sections.runbooks.approved": "Runbook faili apstiprināti",
  "a3PaySetup.production.sections.runbooks.description": "Rezerves kopijas, incidenti, saskaņošana un piekļuves pārbaude ir gatava pirms pārejas",
  "a3PaySetup.production.sections.runbooks.filesPresent": "{ready}/{total} faili pieejami",
  "a3PaySetup.production.sections.runbooks.title": "Runbooks",
  "a3PaySetup.production.sections.scope.channel": "Kanāls",
  "a3PaySetup.production.sections.scope.description": "Tirgotāja un kanāla vārtu konteksts",
  "a3PaySetup.production.sections.scope.directoryMerchant": "Direktorijas tirgotājs",
  "a3PaySetup.production.sections.scope.title": "Tvērums",
  "a3PaySetup.production.sections.standaloneDemo.description": "Table Service un A3 Pay darbojas, kad avota sistēma nav pieejama",
  "a3PaySetup.production.sections.standaloneDemo.evidenceRecorded": "Pierādījums ierakstīts",
  "a3PaySetup.production.sections.standaloneDemo.latestEvidence": "Jaunākais pierādījums",
  "a3PaySetup.production.sections.standaloneDemo.latestEvidenceRecorded": "{date} · pierādījums ierakstīts",
  "a3PaySetup.production.sections.standaloneDemo.sourceOffline": "Maksājuma demo bez avota sistēmas",
  "a3PaySetup.production.sections.standaloneDemo.title": "Standalone demo",
  "a3PaySetup.production.status.blocked": "Bloķēts",
  "a3PaySetup.production.status.needsReview": "Jāpārskata",
  "a3PaySetup.production.summary.environment": "Vide",
  "a3PaySetup.production.summary.isolation": "Izolācija",
  "a3PaySetup.production.summary.onSiteRemittance": "Klātienes izmaksas",
  "a3PaySetup.production.summary.providerActions": "Sniedzēja darbības",
  "a3PaySetup.production.summary.releaseGate": "Publicēšanas vārti",
  "a3PaySetup.production.summary.uiMode": "UI režīms",
  "a3PaySetup.receipts.automatic.futureA3Pay": "Sūtīt čekus automātiski nākamajiem A3 Pay maksājumiem.",
  "a3PaySetup.receipts.automatic.recognized": "Sūtīt čekus automātiski, kad A3 Pay mani atpazīst.",
  "a3PaySetup.receipts.emailAlreadySaved": "Šim maksājumam čeka e-pasts jau ir saglabāts: {email}",
  "a3PaySetup.receipts.emailOptional": "E-pasts nav obligāts. Tas tiks izmantots tikai šim čekam, ja vien neizvēlēsieties automātiskos čekus.",
  "a3PaySetup.receipts.emailOptionalNotice": "E-pasts nav obligāts. Pievienojiet to tikai tad, ja vēlaties čeku e-pastā.",
  "a3PaySetup.receipts.emailReceipt": "Čeks e-pastā",
  "a3PaySetup.receipts.includeMerchantOffers": "Iekļaut tirgotāja piedāvājumus, kad tie ir pieejami.",
  "a3PaySetup.receipts.includeMerchantOffersWhenAvailable": "Iekļaut tirgotāja apstiprinātus piedāvājumus, kad tie ir pieejami.",
  "a3PaySetup.receipts.paymentCompleteAwaitingFiscal": "Maksājums ir pabeigts. Fiskālais čeks vēl tiek sagatavots, tāpēc e-pasta piegāde pagaidīs.",
  "a3PaySetup.receipts.preferenceEmail": "Čeka e-pasts",
  "a3PaySetup.receipts.settingsActionNotMine": "Zemāk varat apturēt šos čekus.",
  "a3PaySetup.receipts.settingsActionPromoOptOut": "Zemāk varat izslēgt tirgotāja piedāvājumus.",
  "a3PaySetup.receiptTemplates.active": "Aktīvās",
  "a3PaySetup.receiptTemplates.description": "Tirgotāja sūtītāja un lokalizācijas veidnes",
  "a3PaySetup.receiptTemplates.from": "No",
  "a3PaySetup.receiptTemplates.noTemplates": "Nav veidņu.",
  "a3PaySetup.receiptTemplates.preview": "Priekšskatījums",
  "a3PaySetup.receiptTemplates.receiptTemplateActivated": "Čeka veidne aktivizēta.",
  "a3PaySetup.receiptTemplates.receiptTemplateRolledBack": "Čeka veidne atgriezta.",
  "a3PaySetup.receiptTemplates.receiptTemplateSaved": "Čeka veidne saglabāta.",
  "a3PaySetup.receiptTemplates.template": "Veidne",
  "a3PaySetup.receiptTemplates.title": "Čeku veidnes",
  "a3PaySetup.sections.diagnostics.description": "Atbalstam, finansēm un atbilstības problēmu risināšanai. Tehniskās sniedzēja, notikumu un pierādījumu atsauces paliek šeit.",
  "a3PaySetup.sections.diagnostics.title": "Papildu diagnostika",
  "a3PaySetup.sections.evidence.description": "Planšetes un darbvirsmas skats finanšu, atbalsta un saskaņošanas pārbaudēm. Iestatīšana paliek galvenā plūsma.",
  "a3PaySetup.sections.evidence.title": "Pierādījumi un saskaņošana",
  "a3PaySetup.sections.operations.description": "Ikdienas maksājumu darbs ir atdalīts no pirmreizējās iestatīšanas.",
  "a3PaySetup.sections.operations.title": "Ikdienas maksājumu operācijas",
  "a3PaySetup.sections.setup.description": "Izpildiet sešas pārbaudes, kas nosaka, vai šī vieta var pieņemt Table Service rēķinu maksājumus.",
  "a3PaySetup.sections.setup.title": "Iestatīšanas saraksts",
  "a3PaySetup.status.available": "Pieejams",
  "a3PaySetup.status.needsReview": "Jāpārskata",
  "a3PaySetup.status.needsSetup": "Jāiestata",
  "a3PaySetup.status.ready": "Gatavs",
  "a3PaySetup.status.underReview": "Pārbaudē",
  "a3PaySetup.status.waiting": "Gaida",
  "a3PaySetup.evidence.columns.action": "Darbība",
  "a3PaySetup.evidence.columns.area": "Zona",
  "a3PaySetup.evidence.columns.metric": "Metrika",
  "a3PaySetup.evidence.columns.status": "Statuss",
  "a3PaySetup.evidence.desktopOnly": "Detalizēta pierādījumu pārskatīšana un eksporta tipa darbības ir pieejamas planšetē vai darbvirsmā.",
  "a3PaySetup.evidence.paymentMatching.detail": "Atvērtās saskaņošanas problēmas sniedzēja un termināļa norēķinu pierādījumos.",
  "a3PaySetup.evidence.paymentMatching.title": "Maksājumu saskaņošana",
  "a3PaySetup.evidence.payoutInstructions.detail": "Aizturēti vai neizdevušies izmaksu instrukciju ieraksti.",
  "a3PaySetup.evidence.payoutInstructions.title": "Izmaksu instrukcijas",
  "a3PaySetup.evidence.protectedFunds.detail": "Pieejamais aizsargātais atlikums pirms izmaksas izpildes.",
  "a3PaySetup.evidence.protectedFunds.title": "Aizsargātie līdzekļi",
  "a3PaySetup.evidence.providerUpdates.detail": "Maksājumu aiztures un sniedzēja atjauninājumu brīdinājumi.",
  "a3PaySetup.evidence.providerUpdates.title": "Sniedzēja atjauninājumi",
  "a3PaySetup.evidence.tableLabel": "Pierādījumu un saskaņošanas pārskats",
  "a3PaySetup.evidence.terminalSettlement.detail": "Licencētā pieņēmēja termināļa pierādījumi ar atvērtām saskaņošanas atšķirībām.",
  "a3PaySetup.evidence.terminalSettlement.title": "Termināļa norēķini",
  "a3PaySetup.statusPage.checkingPayment": "Pārbauda maksājumu",
  "a3PaySetup.statusPage.latestUpdate": "Pēdējais notikums",
  "a3PaySetup.statusPage.merchant": "Tirgotājs",
  "a3PaySetup.statusPage.paymentStatus": "Maksājuma statuss",
  "a3PaySetup.statusPage.recentUpdates": "Jaunākie atjauninājumi",
  "a3PaySetup.statusPage.title": "Maksājuma statuss",
  "a3PaySetup.steps.businessProfile.detail": "Apstipriniet uzņēmuma profilu un vietas identitāti, ko izmanto maksājumu pieņemšanai.",
  "a3PaySetup.steps.businessProfile.title": "Uzņēmuma profils",
  "a3PaySetup.steps.methods.detail": "Izvēlieties tiešsaistes un termināļa/card-present metodes, ko viesi var izmantot.",
  "a3PaySetup.steps.methods.title": "Maksājumu metodes",
  "a3PaySetup.steps.payouts.detail": "Apstipriniet izmaksu statusu un maksājumu saskaņošanu pirms līdzekļu nosūtīšanas.",
  "a3PaySetup.steps.payouts.title": "Izmaksas un saskaņošana",
  "a3PaySetup.steps.provider.detail": "Pieslēdziet sniedzēja kontu, ko izmanto viesu maksājumu pieņemšanai.",
  "a3PaySetup.steps.provider.title": "Maksājumu sniedzējs",
  "a3PaySetup.steps.receipts.detail": "Iestatiet čeku e-pasta uzvedību un veidnes, kur tas ir ieslēgts.",
  "a3PaySetup.steps.receipts.title": "Čeki un e-pasti",
  "a3PaySetup.steps.tableService.detail": "Pārbaudiet, ka A3 Table Service rēķini var izveidot viesu maksājumu.",
  "a3PaySetup.steps.tableService.title": "Table Service savienojums",
  "a3PaySetup.summary.description": "Pieņemiet tiešsaistes un termināļa/card-present maksājumus Table Service rēķiniem.",
  "a3PaySetup.summary.launchState.actionNeeded": "Nepieciešama darbība",
  "a3PaySetup.summary.launchState.checkingSetup": "Pārbauda iestatīšanu",
  "a3PaySetup.summary.launchState.paymentsPaused": "Maksājumi apturēti",
  "a3PaySetup.summary.launchState.payoutSetupRequired": "Jāiestata izmaksas",
  "a3PaySetup.summary.launchState.providerSetupRequired": "Jāiestata sniedzējs",
  "a3PaySetup.summary.launchState.readyForOnlinePayments": "Gatavs pieņemt tiešsaistes maksājumus",
  "a3PaySetup.summary.launchState.readyToTest": "Gatavs testēšanai",
  "a3PaySetup.summary.launchState.serviceIssue": "Servisa problēma",
  "a3PaySetup.summary.launchState.underReview": "Pārbaudē",
  "a3PaySetup.summary.nextAction": "Nākamais: {action}",
  "a3PaySetup.summary.nextActionReady": "Maksājumi ir gatavi.",
  "a3PaySetup.summary.progress": "{ready} no {total} soļiem gatavi",
  "a3PaySetup.summary.title": "A3 Pay iestatīšana",
  "a3PaySetup.diagnostics.providerAccounts.detail": "Sniedzēja konta tehniskais statuss un importētās konta atsauces.",
  "a3PaySetup.diagnostics.providerAccounts.title": "Sniedzēja konti",
  "a3PaySetup.diagnostics.providerUpdates.detail": "Sniedzēja atjauninājumu stāvoklis un maksājumu notikumu aizkave.",
  "a3PaySetup.diagnostics.providerUpdates.title": "Sniedzēja atjauninājumi",
  "a3PaySetup.diagnostics.payoutInstructions.detail": "Izmaksu instrukciju atsauces, aiztures un neveiksmīga izmaksu ievade.",
  "a3PaySetup.diagnostics.payoutInstructions.title": "Izmaksu instrukcijas",
  "a3PaySetup.diagnostics.terminalSettlement.detail": "Termināļa/card-present pierādījumi no licencēta pieņēmēja norēķiniem.",
  "a3PaySetup.diagnostics.terminalSettlement.title": "Termināļa norēķini",
  "a3PaySetup.trace.availableFunds": "Pieejamie līdzekļi",
  "a3PaySetup.trace.dailyPayouts": "Dienas izmaksas",
  "a3PaySetup.trace.dailyResiduals": "Dienas atlikumi",
  "a3PaySetup.trace.header.badge": "Operāciju izsekošana",
  "a3PaySetup.trace.header.description": "Atbalsts un finanses var izsekot avota formulai -> nemainīgam plānam -> izmaksas instrukcijai -> izmaksai, neatverot ārēju administrāciju.",
  "a3PaySetup.trace.header.title": "Izsekot maksājumam",
  "a3PaySetup.trace.heldSettlements": "Aizturētas izmaksas",
  "a3PaySetup.trace.immutablePlan.detail": "Plāna atsauce un hash piesaista saņēmēju summas avota pierādījumiem.",
  "a3PaySetup.trace.immutablePlan.title": "Nemainīgs plāns",
  "a3PaySetup.trace.eventEvidence.detail": "Event dati tiek glabāti tikai kā avota pierādījumi; A3 Pay nepārvalda Event sadales noteikumus.",
  "a3PaySetup.trace.eventEvidence.sourceOnly": "Tikai avota pierādījums",
  "a3PaySetup.trace.eventEvidence.title": "Event pierādījumi",
  "a3PaySetup.trace.eventRef": "Event atsauce",
  "a3PaySetup.trace.eventSnapshot": "Event snapshot hash",
  "a3PaySetup.trace.fiscalEvidence.detail": "Fiskālās atsauces un artefaktus piegādā A3 Venue Bridge vai A3 Fiscal Register.",
  "a3PaySetup.trace.fiscalEvidence.title": "Fiskālie pierādījumi",
  "a3PaySetup.trace.fiscalIntent": "Fiskālais nodoms",
  "a3PaySetup.trace.fiscalOwner": "Fiskālais īpašnieks",
  "a3PaySetup.trace.fiscalRef": "Fiskālā atsauce",
  "a3PaySetup.trace.latestEvent": "Pēdējais notikums",
  "a3PaySetup.trace.links.paymentAcceptance": "Maksājumu pieņemšana un sniedzēji",
  "a3PaySetup.trace.links.protectedRemittance": "Aizsargāto līdzekļu izmaksas",
  "a3PaySetup.trace.links.reconciliationBreaks": "Maksājumu saskaņošanas problēmas",
  "a3PaySetup.trace.openBreaks": "Atvērtas neatbilstības",
  "a3PaySetup.trace.openReviews": "Atvērtas pārbaudes",
  "a3PaySetup.trace.merchantEvidence.detail": "Tirgotāja un īpašnieka pierādījumi ir redzami bez raw directory payloadiem.",
  "a3PaySetup.trace.merchantEvidence.title": "Tirgotājs un īpašnieks",
  "a3PaySetup.trace.merchantSnapshot": "Tirgotāja snapshot",
  "a3PaySetup.trace.ownerParty": "Īpašnieka Party",
  "a3PaySetup.trace.ownerSnapshot": "Īpašnieka snapshot",
  "a3PaySetup.trace.paymentEvents.detail": "Sniedzēja statuss ir redzams bez sniedzēja tehnisko datu lasīšanas.",
  "a3PaySetup.trace.paymentEvents.title": "Maksājuma pieprasījums un notikumi",
  "a3PaySetup.trace.paymentHolds": "Aizturēti maksājumi",
  "a3PaySetup.trace.paymentStatus": "Maksājuma statuss",
  "a3PaySetup.trace.planHash": "Plāna hash",
  "a3PaySetup.trace.planRef": "Plāna atsauce",
  "a3PaySetup.trace.profileVersion": "Profila versija",
  "a3PaySetup.trace.provider": "Sniedzējs",
  "a3PaySetup.trace.providerMode": "Sniedzēja režīms",
  "a3PaySetup.trace.providerSession": "Hosted sesija",
  "a3PaySetup.trace.queueItems": "Rindas ieraksti",
  "a3PaySetup.trace.reason": "Iemesls",
  "a3PaySetup.trace.recipientTotal": "Saņēmēju kopsumma",
  "a3PaySetup.trace.relatedPayouts": "Saistītās izmaksas",
  "a3PaySetup.trace.riskHolds": "Riska aiztures",
  "a3PaySetup.trace.safeguardedFunds.detail": "Līdzekļi ir grupēti pēc avota kredīta, tirgotāja un kanāla.",
  "a3PaySetup.trace.safeguardedFunds.title": "Aizsargātie līdzekļi",
  "a3PaySetup.trace.sent": "Nosūtīts",
  "a3PaySetup.trace.settlementInstruction.created": "Izveidots",
  "a3PaySetup.trace.settlementInstruction.detail": "A3 Pay var pieņemt, aizturēt vai noraidīt, nemainot avota noteikumus.",
  "a3PaySetup.trace.settlementInstruction.instruction": "Instrukcija",
  "a3PaySetup.trace.settlementInstruction.title": "Izmaksas instrukcija",
  "a3PaySetup.trace.sourceFormula.detail": "Avota sistēma pārvalda saņēmēju noteikumus un aprēķinu pierādījumus.",
  "a3PaySetup.trace.sourceFormula.a3PayFormula": "Bez A3 Pay formulas",
  "a3PaySetup.trace.sourceFormula.owner": "Īpašnieks",
  "a3PaySetup.trace.sourceFormula.sourceManagedCopy": "Avota pārvaldītā režīmā īpašnieks paliek avota sistēma. Patstāvīgā režīmā pārvaldība paliek A3 Table Service. A3 Pay neaprēķina formulas.",
  "a3PaySetup.trace.sourceFormula.sourceRef": "Avota atsauce",
  "a3PaySetup.trace.sourceFormula.title": "Avota formula",
  "a3PaySetup.trace.sourceOwner.coopPlatform": "Pārvalda avota platforma",
  "a3PaySetup.trace.sourceOwner.notRecorded": "Avota sistēma nav ierakstīta",
  "a3PaySetup.trace.sourceOwner.tableServiceStandalone": "Pārvalda A3 Table Service standalone",
  "a3PaySetup.trace.status.needsEvidence": "Vajadzīgi pierādījumi",
  "a3PaySetup.trace.status.ready": "Gatavs",
  "a3PaySetup.trace.remittance.detail": "Izmaksas, aiztures un maksājumu saskaņošanas problēmas var izsekot vienā darba vietā.",
  "a3PaySetup.trace.remittance.title": "Izmaksas un maksājumu saskaņošana",
};

export default a3PaySetupLv;
